import React, {Component} from 'react';
import swal from 'sweetalert';
import moment from 'moment';
import {translate} from 'react-i18next';
import Help from '../../generics/help';
import TableWorkList from '../../work_list/components/TableWorkList';
import { Table, Pager } from 'react-bootstrap';
import RaisedButton from 'material-ui/RaisedButton';

var Config = require('../../../config');
const style = {
    margin: 7,
};

class ReagentConsuption extends Component{
    constructor(props){
        super(props);

        this.handleChange = this.handleChange.bind(this);
        this.onSearch = this.onSearch.bind(this);
        this.checkAll = this.checkAll.bind(this);
        this.checkOne = this.checkOne.bind(this);
        this.checkOneColumn = this.checkOneColumn.bind(this);
        this.changeComboColumn = this.changeComboColumn.bind(this);
        this.changeComboList = this.changeComboList.bind(this);

        this.onSave = this.onSave.bind(this);
        this.cancel = this.cancel.bind(this);

        this.state = {
            lab_sections:[],
            lab_section_id:"",
            start_date:moment().format('YYYY-MM-DD'),
            end_date:moment().format('YYYY-MM-DD'),
            start_folio:"",
            end_folio:"",
            hf_id: sessionStorage.getItem('health_facilities_id'),
            columns:[],
            list:[],
            pagination:[]
        }
    }

    componentDidMount(){
        
        fetch(Config.default.apiGateway.URL+'lab_sections/byUser?health_facilities_id='+this.state.hf_id, {
            method: 'GET',
            headers: new Headers({
                'Authorization'	: 'Bearer '+sessionStorage.getItem('token'),
                'Accept'		: 'application/json',
                'Content-Type'	: 'application/json'
            })
        }).then(res => {
            if(res.ok){
                return res.json();
            }else{
                res.text().then((msg)=>{
                    swal('Error', msg, 'error');
                });
            }
        }).then(response => {
            if(response !== undefined){

                this.setState({
                    lab_sections: response
                });

            }
        });

        fetch(Config.default.apiGateway.URL+'offers?option=date',{ 
		    method: 'get',
		    headers: new Headers({
		       'Authorization': 'Bearer ' + sessionStorage.getItem("token") , 
		       'Accept': 'application/json',
		        'Content-Type': 'application/json',
		    })
		})
		.then(response => response.json())
		.then(response => {
			var aux = response.split('|');
			var date = aux[0].split("/");

			this.setState({
				start_date:date[2]+'-'+date[1]+'-'+date[0],
				end_date:date[2]+'-'+date[1]+'-'+date[0]
			});
		})
        
    }

    handleChange(e, i, j){
        this.setState({[e.target.name]: e.target.value});
    }

    onSearch(){
        this.props.waiting.handleShow('Buscando...');
        fetch(Config.default.apiGateway.URL+'samples_use_reagents/search?hf_id='+this.state.hf_id+
            '&ls_id='+this.state.lab_section_id+'&start_date='+this.state.start_date+'&end_date='+this.state.end_date+
            '&start_folio='+this.state.start_folio+'&end_folio='+this.state.end_folio,{
            method:'GET',
            headers: new Headers({
                'Authorization' : 'Bearer '+sessionStorage.getItem('token'),
                'Content-Type'  : 'application/json',
                'Accept'        : 'application/json'
            })
        }).then(res => {
            this.props.waiting.handleClose();
            if(res.ok){
                return res.json();
            }else{
                res.text().then(msg => {
                    swal('Error', msg, 'error');
                });
            }
        }).then(response => {
            if(response !== undefined){
                var columns = [];
                var main = [
                    {with_check: true, check: false, name:'Tipo'},
                    {with_check: false, check: false, name:'No. Donación/Muestra'}
                ];
                var second = [];

                response.analitical_tests.forEach(test => {
                    main.push(
                        {name:test.name, id:test.id, with_check:false, colSpan:test.reagents.length}
                    );

                    test.reagents.forEach(reagent => {                        
                        second.push(
                            {
                                with_check: true,
                                check: false,
                                name: reagent.name,
                                selected:"",
                                combo: reagent.stock
                            }
                        );
                    });
                });

                columns = [main, second];

                var list = [];
                response.samples.forEach(sample => {
                    var obj = {
                        check:false,
                        id: sample.id,
                        type: sample.type,
                        number: sample.number,
                        assigned_test:[]
                    };

                    response.analitical_tests.forEach(test => {
                        var index = sample.assigned_tests.findIndex(item => item === test.id);

                        if(index !== -1){
                            response.analitical_tests[index].reagents.forEach(test => {                                
                                var aux = {
                                    show:true,
                                    id:test.id,
                                    analitical_test_id: response.analitical_tests[index].id,
                                    supplies_reagents_id: test.id,
                                    selected:"",
                                    combo: test.stock
                                };

                                var index1 = sample.reagents.findIndex(item => item.analitical_test_id === response.analitical_tests[index].id && item.supplies_reagents_id === test.id);

                                if(index1 !== -1){
                                    obj.check = true;
                                    aux.selected = sample.reagents[index1].lot_number;
                                }

                                obj.assigned_test.push(aux);
                            });
                        }else{
                            obj.assigned_test.push({show:false});
                        }
                        
                    });
                    
                    list.push(obj);
                })

                console.log(list)

                this.setState({
                    columns: columns, 
                    list: list
                });
                this.paginator(list);
            }
        })
    }

    checkAll(e){
        var columns = this.state.columns;

        columns[0][0].check = e.target.checked;

        var list = this.state.list;
        list.forEach(list => {
            list.check = e.target.checked;
        });

        this.setState({list: list, columns: columns});
        
    }

    checkOneColumn(e, i, j){
        var columns = this.state.columns;

        columns[i][j].check = e.target.checked;

        if(columns[i][j].check){
            var list = this.state.list;

            list.forEach(l => {     
                l.assigned_test[j].selected = columns[i][j].selected;
            })
                        
            this.setState({list: list});
        }

        this.setState({columns: columns});
    }

    checkOne(e, i){
        var list = this.state.list;

        list[i].check = e.target.checked;

        this.setState({list: list});
    }

    changeComboColumn(e, i, j){
        var columns = this.state.columns;

        columns[i][j].selected = e.target.value;
        
        if(columns[i][j].check){
            var list = this.state.list;

            list.forEach(l => {                
                l.assigned_test[j].selected = e.target.value;
            })

            this.setState({list: list});
        }


        this.setState({columns:columns});

    }

    changeComboList(e, i, j){
        
        var list = this.state.list;
        
        list.forEach(item => {
            if(item.id === i){
                var index = item.assigned_test.findIndex(obj => obj.id === j);

                if(index !== -1){
                    item.assigned_test[index].selected = e.target.value;
                }
            }
        });


        this.setState({list: list});
    }

    onSave(){
        var obj = [];

        var list = this.state.list;

        list.forEach(item => {
            var element = {};
            if(item.check){
                element.id = item.id;
                element.reagents = [];

                item.assigned_test.forEach(test => {
                    if(test.show){
                        if(test.selected !== ""){
                            element.reagents.push({
                                analitical_test_id: test.analitical_test_id,
                                supplies_reagents_id: test.supplies_reagents_id,
                                lot_number: test.selected
                            });
                        }
                    }

                });

                obj.push(element);
            }
        });

        if(obj.length > 0){
            this.props.waiting.handleShow('Guardando...');
            fetch(Config.default.apiGateway.URL+'samples_use_reagents', {
                method:'POST',
                body:JSON.stringify(obj),
                headers: new Headers({
                    'Authorization' : 'Bearer '+sessionStorage.getItem('token'),
                    'Content-Type'  : 'application/json',
                    'Accept'        : 'application/json'
                })
            }).then(res => {
                this.props.waiting.handleClose();
                if(res.ok){
                    return res.json();
                }else{
                    res.text().then(msg => {
                        swal('Error', msg, 'error');
                    });
                }
            }).then(response => {
                if(response !== undefined){
                    swal('Correcto', 'Se guardaron los datos correctamente', 'success');
                    
                    this.setState({
                        lab_section_id:"",
                        start_date:moment().format('YYYY-MM-DD'),
                        end_date:moment().format('YYYY-MM-DD'),
                        start_folio:"",
                        end_folio:"",
                        hf_id: sessionStorage.getItem('health_facilities_id'),
                        columns:[],
                        list:[],
                        pagination:[]
                    })
                }
            });
        }

    }

    cancel(){
        this.props.history.push('/');
    }
    
    paginator(item, page, per_page){
        var page        = page || 1,
        per_page        = per_page || 10,
        offset          = (page - 1) * per_page,
        paginatedItems  = item.slice(offset).slice(0, per_page),
        total_pages     = Math.ceil(item.length / per_page);
        var pagination  = {
            page        : page,
            per_page    : per_page,
            pre_page    : page - 1 ? page - 1 : null,
            next_page   : (total_pages > page) ? page + 1 : null,
            total       : item.length,
            total_pages : total_pages,
            work_list   : item.id,
            data        : paginatedItems
        }
        
        if(this.state.pagination.length === 0){
          this.setState({
            pagination:[...this.state.pagination, pagination]
          })
    
        }else{
            var paginator = this.state.pagination;
          
            paginator[0] = pagination;
            
            setTimeout(()=>{
                this.setState({
                    pagination: paginator
                });
    
                //this.editValues();
            }, 500);
        }       
    }

    render(){
        const {t} = this.props;

		return (
			<div className="col-xs-12">
        		<div className="route">
          			<h5 className="title_page" >
			            {sessionStorage.getItem('health_facilities_name')} ->
			            {t('sidebar.nav.laboratory.MAIN')} -> 
			            Consumo de Reactivos
          			</h5>
        		</div>
            
        		<Help 
          			{...this.props}
            		menu={"help_laboratory"} 
            		submenu={"help_reagent_consumption"}  />

        		<div className="col-xs-12">
                    <div className="col-xs-12 form-group">
                        <div className="col-xs-12 col-sm-2">
                            <span className="span-min">Sección de Laboratorio</span>
                            <select className="form-control" name="lab_section_id" id="lab_section_id" value={this.state.lab_section_id}
                                onChange={(e)=>this.handleChange(e)}>
                                <option value="">Seleccione...</option>
                                {this.state.lab_sections.map((lab, i)=>
                                    <option value={lab.lab_sections_id} key={i}>{lab.name}</option>
                                )}
                            </select>
                        </div>
                        <div className="col-xs-12 col-sm-1">
                            <span className="span-min">Fecha Inicio</span>
                            <input type="date" className="form-control hour-input" name="start_date" id="start_date" value={this.state.start_date}
                                onChange={(e)=>this.handleChange(e)} />
                        </div>
                        <div className="col-xs-12 col-sm-1">
                            <span className="span-min">Fecha Fin</span>
                            <input type="date" className="form-control hour-input" name="end_date" id="end_date" value={this.state.end_date}
                                onChange={(e)=>this.handleChange(e)} />
                        </div>
                        <div className="col-xs-12 col-sm-1">
                            <span className="span-min">Folio Inicio</span>
                            <input type="number" className="form-control hour-input" name="start_folio" id="start_folio" value={this.state.start_folio}
                                onChange={(e)=>this.handleChange(e)} />
                        </div>
                        <div className="col-xs-12 col-sm-1">
                            <span className="span-min">Folio Fin</span>
                            <input type="number" className="form-control hour-input" name="end_folio" id="end_folio" value={this.state.end_folio}
                                onChange={(e)=>this.handleChange(e)} />
                        </div>
                        <div className="col-xs-12 col-sm-1" style={{marginTop:18}}>
                            <button className="btn btn-info" onClick={()=>this.onSearch()}>Buscar</button>
                        </div>
                    </div>
                    
                    <div className="col-xs-12 form-group">
                        <Table responsive hover>
                            <thead>
                                {this.state.columns.map((columns, i)=>
                                    <tr key={i}>
                                        {columns.map((col, j)=>
                                            i === 0 && j < 2 ?
                                                <th rowSpan="2" key={j}>
                                                    {col.with_check &&
                                                        <input type="checkbox" value={col.check} checked={col.check} 
                                                            style={{marginRight:8}} onChange={(e)=>this.checkAll(e)}
                                                        />
                                                    }
                                                    {col.name}
                                                </th>
                                            :
                                                <th key={j} colSpan={col.colSpan} style={{textAlign:'center'}}>
                                                    {col.with_check &&
                                                        <input type="checkbox" value={col.check} checked={col.check} 
                                                            style={{marginRight:8}} onChange={(e)=>this.checkOneColumn(e, i, j)}
                                                        />
                                                    }
                                                    {col.name}
                                                    <div>
                                                        {col.combo !== undefined &&
                                                            <select className="form-control" name={col.name} id={col.name}
                                                                value={col.selected} onChange={(e)=>this.changeComboColumn(e, i, j)}>
                                                                <option value="">Seleccion...</option>
                                                                {col.combo.map((c, k)=>
                                                                    <option key={k} value={c.lot_number}>{c.lot_number}</option>
                                                                )}
                                                            </select>
                                                        }
                                                    </div>
                                                </th>
                                        )}
                                    </tr>
                                )}
                            </thead>
                            <tbody>
                                {this.state.pagination.map((pag, i)=>
                                    pag.data.length > 0 &&
                                        pag.data.map((list, i)=>
                                            <tr key={i}>
                                                <td>{console.log(list)}
                                                    <input type="checkbox" value={list.check} checked={list.check}
                                                        onChange={(e)=>this.checkOne(e, i)} style={{marginRight:8}} />
                                                    {list.type}
                                                </td>
                                                <td>
                                                    {list.number}
                                                </td>
                                                {list.assigned_test.map((test, j)=>
                                                    test.show ?                                                                                                 
                                                        <td key={j}>            
                                                            <select className="form-control" 
                                                                value={test.selected} 
                                                                onChange={(e)=>this.changeComboList(e, list.id, test.id)}>
                                                                <option value="">Seleccion...</option>
                                                                {test.combo.map((c, k)=>
                                                                    <option key={k} value={c.lot_number}>{c.lot_number}</option>
                                                                )}
                                                            </select>
                                                        </td>
                                                        
        
                                                    : <td key={j}></td>
                                                )}
                                            </tr>
                                        )
                                )}
                            </tbody>
                        </Table>

                        {this.state.pagination[0] !== undefined ?
                            <Pager>                          
                                <Pager.Item disabled={this.state.pagination[0].pre_page === null ? true : false}
                                    onClick={()=>this.paginator(this.state.list, this.state.pagination[0].pre_page)} 
                                    href="#">Anterior</Pager.Item>
                                {' Página '+this.state.pagination[0].page+' de '+this.state.pagination[0].total_pages+' '}
                                <Pager.Item disabled={this.state.pagination[0].next_page === null ? true : false} 
                                    onClick={()=>this.paginator(this.state.list, this.state.pagination[0].next_page)} 
                                    href="#">Siguiente</Pager.Item>                            
                            </Pager>
                        :null}
                    </div>
                    {this.state.list.length > 0 &&
                        <div className="col-xs-12" style={{textAlign:"center"}}>
                            <RaisedButton className="action-btn" label={t('content.generics.buttons.save')} primary={true} onClick={this.onSave} style={style}/>
                            <RaisedButton className="action-btn" label={t('content.generics.buttons.reset')} primary={true} onClick={this.cancel} style={style}/>
                        </div>
                    }
                </div>
            </div>
        )
    }
}

export default translate('translations')(ReagentConsuption);